<template>
  <div class="animated revealUp">
    <div class="white-wrapper">
      <div class="section-title">{{ $t("Movie Show Wise Report") }}</div>
      <small
        ><em>{{ $t("* As Per show Date") }}</em></small
      >
      <div class="mt-3 mb-2">
        <div class="row">
          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="dropdown-curve-container">
              <label
                :class="
                  dropDown.selectedCinema ? 'shift-up' : 'font-weight-bold'
                "
                >{{ $t("select") }} {{ $tc("cinema", 1) }}</label
              >
              <multiselect
                :disabled="isRoleID"
                :options="dropDown.cinemas"
                v-model="dropDown.selectedCinema"
                :searchable="true"
                label="cine_name"
                track-by="cine_id"
                placeholder="Select Cinema"
                @input="onSelectCinema"
                :allowEmpty="true"
                :showLabels="false"
                :multiple="true"
                :close-on-select="true"
              ></multiselect>
            </div>
          </div>

          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <Datepicker
                  :monday-first="true"
                  type="date"
                  ref="programaticOpen"
                  v-model="fromDate"
                  v-validate="'required'"
                  @selected="onChangeDate($event, 'from')"
                ></Datepicker>
                <label :class="fromDate ? 'active' : ''">
                  {{ $t("showdate") }}
                </label>
              </div>
            </div>
          </div>

          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="dropdown-curve-container">
              <label
                :class="
                  selectedMovieName && selectedMovieName.length
                    ? 'shift-up'
                    : ''
                "
                >Movies</label
              >
              <multiselect
                v-model="selectedMovieName"
                :options="allMovieNames || []"
                track-by="movie_name"
                label="movie_name"
                :disabled="isRoleID"
                :searchable="true"
                placeholder=""
                :multiple="true"
                :close-on-select="true"
              >
              </multiselect>
            </div>
          </div>

          <div class="col-lg-6 col-xl-2 align-self-center mb-3">
            <button
              class="btn-blue-lg w-100"
              @click.prevent="getShowDetailsData('N', 'N')"
            >
              {{ $t("fetch") }}
            </button>
          </div>

          <div
            class="col-lg-6 col-xl-12 align-self-center mb-2 d-flex justify-content-end align-items-center"
            v-if="showDetailsData.length > 0"
          >
            <div class="mx-1">{{ $t("download") }} as:</div>

            <span
              @click="getShowDetailsData('Y', 'N')"
              title="Download as Pdf"
              style="cursor: pointer"
            >
              <img src="@/assets/img/icons/pdf.svg" height="25" width="25" />
            </span>
            <span
              @click="getShowDetailsData('N', 'Y')"
              title="Download as Excel"
              style="cursor: pointer"
            >
              <img src="@/assets/img/icons/excel.svg" height="25" width="25" />
            </span>
          </div>
        </div>
      </div>

      <div>
        <div
          v-if="showDetailsData.length > 0"
          style="overflow-x: scroll; width: auto !important"
        >
          <table
            class="swc-report-table swc_table_header"
            border="1"
            v-if="showDetailsData.length > 0"
          >
            <thead class="bg-lightgrey">
              <tr>
                <th>Cinema Name</th>
                <th>Start Time</th>
                <th>Screen</th>
                <th>Capacity</th>
                <th>Booked</th>
                <th>Available</th>
                <th>Occupancy %</th>
              </tr>
            </thead>
            <template v-for="(movieData, DataIndex) in showDetailsData">
              <tr>
                <td class="text-left">{{ movieData.cinema_name }}</td>
                <td class="text-right">
                  {{ movieData.show_time }}
                </td>
                <td class="text-left">{{ movieData.screen_name }}</td>
                <td class="text-right">{{ movieData.available_capacity }}</td>
                <td class="text-right">{{ movieData.admits || 0 }}</td>
                <td class="text-right">
                  {{ movieData.available_capacity - movieData.admits || 0 }}
                </td>
                <td class="text-right">
                  {{
                    currFormat(
                      (movieData.admits / movieData.available_capacity) * 100 ||
                        0
                    )
                  }}%
                </td>
              </tr>
            </template>
            <thead class="bg-lightgrey">
              <tr>
                <th class="text-left">Grand Total</th>
                <th class="text-right"></th>
                <th class="text-right"></th>
                <th class="text-right">{{ grandTotal.total_capacity || 0 }}</th>
                <th class="text-right">{{ grandTotal.admits || 0 }}</th>
                <th class="text-right">{{
                  grandTotal.available_capacity || 0
                }}</th>
                <th class="text-right">
                  {{
                    currFormat(
                      ((grandTotal.admits || 0) /
                        (grandTotal.total_capacity || 1)) *
                        100 || 0
                    )
                  }}%
                </th>
              </tr>
            </thead>
          </table>
        </div>
        <div
          v-if="showDetailsData.length == 0"
          style="overflow-x: scroll; width: auto !important"
        >
          <table class="swc-report-table" border="1">
            <thead class="bg-lightgrey font-weight-bold">
              <tr>
                <th>Cinema Name</th>
                <th>Time</th>
                <th>Screen</th>
                <th>Capacity</th>
                <th>Booked</th>
                <th>Available</th>
                <th>Occ. %</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td colspan="7">
                  <NoRecords />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import { BASEURL } from "@/config/index";
  import MasterService from "@/services/MasterService";
  import ReportsService from "@/services/ReportsService-v2";
  import NewReportService from "../../../services/NewReportService";
  import FnBReportService from "@/services/FnBReportsService";
  import PosFnbService from "@/services/PosFnbService";
  import moment from "moment";
  import NoRecords from "@/components/Partials/NoRecords.vue";
  import xlsx from "json-as-xlsx";
  import { mapState, mapGetters, mapActions } from "vuex";

  export default {
    components: {
      NoRecords,
    },
    computed: {},
    data() {
      return {
        showNegative: "Y",
        showNegativeWatchers: "Y",
        BASEURL,
        isRoleID: false,
        submitted: false,
        dropDown: {
          cinemas: [],
          selectedCinema: null,
          selectedCinemaName: null,
          selectedCinemaId: "",
        },
        selectedCinema: [],
        showDetailsData: [],
        fromDate: null,
        toDate: new Date(),
        disabledAfter: new Date(),
        grandTotal: {},
        disabledDates: {
          from: "",
        },
        allMovieNames: [],
        selectedMovieName: [],
      };
    },
    beforeMount() {},
    watch: {
      fromDate() {
    
        this.getMovieList();
      },
      toDate() {
        this.getMovieList();
      },
 
    },

    mounted() {
      let roleid = this.secureStore.get("USINFO").role_id;
      if (true) {
        this.isRoleID = false;
      }
      let cinemaId =
        this.secureStore.get("USINFO") &&
        this.secureStore.get("USINFO")["cinema_id"]
          ? this.secureStore.get("USINFO").cinema_id
          : null;
      this.getCinemaList(cinemaId);
    },

    methods: {
      async getMovieList() {
        this.allMovieNames = [];
        let cinemaIds = [];
        let cinema_name = "";
        let cinema_address = "";

        if (this.selectedCinema.length) {
          if (this.selectedCinema[0].cine_id === 0) {
            cinemaIds = this.CinemasCopy.map((cinema) => cinema.cine_id);
            cinema_name = "All Cinema";
            cinema_address = "";
          } else {
            cinemaIds = this.selectedCinema.map((cinema) => cinema.cine_id);
            if (this.selectedCinema.length === 1) {
              cinema_name = this.selectedCinema[0].cine_name || "";
              cinema_address = this.selectedCinema[0].cine_address || "";
            } else {
              cinema_name = this.selectedCinema
                .map((cinema) => cinema.cine_name)
                .join(", ");
              cinema_address = this.selectedCinema
                .map((cinema) => cinema.cine_address)
                .filter((addr) => addr)
                .join(", ");
            }
          }
        }

        let payload = {
          cinema_id: cinemaIds,
          cinema_name: cinema_name,
          cinema_address: cinema_address,
          fromDate: moment(this.fromDate).format("YYYY-MM-DD"),
          toDate: moment(this.toDate).format("YYYY-MM-DD"),
        };
        console.log("payload:", payload);
        let response = await NewReportService.GetScheduleMovieList(
          payload
        ).then((response) => {
          const { data } = response;
          console.log("response:", response);
          if (data.status && data.Records) {
            // this.allMovieNames = [...data.Records];
           this.allMovieNames = [...data.Records].sort((a, b) =>
  (a.movie_name || "").localeCompare(b.movie_name || "")
);
          } else {
            this.$toasted.show(data.message);
          }
        });
      },
      getCinemaList: function() {
        MasterService.GetCinemasByRoles()
          .then((response) => {
            const { data } = response;
            if (data.status && data.Records.length > 0) {
              this.dropDown.cinemas = [
                { cine_id: 0, cine_name: "All Cinema" },
                ...data.Records,
              ];
              this.CinemasCopy = data.Records;
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError);
      },
      onChangeDate(e, type) {
        if (type == "from") {
          this.toDate = new Date(e);
          this.$forceUpdate();
        }
        if (type == "to") {
          this.$forceUpdate();
        }
      },
      onSelectCinema: function(event) {
        this.selectedCinema = event;

        if (event.length > 0) {
          if (event[event.length - 1].cine_name == "All Cinema") {
            this.dropDown.cinemas = this.dropDown.cinemas.map((cinema) => ({
              ...cinema,
              $isDisabled: true,
            }));
            // Enable "All Cinema" option
            const allCinema = this.dropDown.cinemas.find(
              (cinema) => cinema.cine_name == "All Cinema"
            );
            if (allCinema) {
              allCinema.$isDisabled = false;
            }
            console.log("1");
          } else {
            this.dropDown.cinemas = this.dropDown.cinemas.map((cinema) => ({
              ...cinema,
              $isDisabled: cinema.cine_name == "All Cinema",
            }));
            console.log("2");
          }
        } else {
          this.dropDown.cinemas = this.dropDown.cinemas.map((cinema) => ({
            ...cinema,
            $isDisabled: false,
          }));
          console.log("3");
        }
      },
      async getShowDetailsData(isPdf, isExcel, type = "") {
        if (!this.fromDate) {
          this.$toasted.show("Please select from date");
          return;
        }
        if (!this.selectedMovieName || this.selectedMovieName.length === 0) {
  this.$toasted.show("Please Select Movie");
  return;
}
        let loader = this.$loading.show();
        try {
          let cinemaIds = [];
          let cinema_name = "";
          let cinema_address = "";

          if (this.selectedCinema.length) {
            if (this.selectedCinema[0].cine_id === 0) {
              cinemaIds = this.CinemasCopy.map((cinema) => cinema.cine_id);
              cinema_name = "All Cinema";
              cinema_address = "";
            } else {
              cinemaIds = this.selectedCinema.map((cinema) => cinema.cine_id);
              if (this.selectedCinema.length === 1) {
                cinema_name = this.selectedCinema[0].cine_name || "";
                cinema_address = this.selectedCinema[0].cine_address || "";
              } else {
                cinema_name = this.selectedCinema
                  .map((cinema) => cinema.cine_name)
                  .join(", ");
                cinema_address = this.selectedCinema
                  .map((cinema) => cinema.cine_address)
                  .filter((addr) => addr)
                  .join(", ");
              }
            }
          }

          let payload = {
            cinema_id: cinemaIds,
            cinema_name: cinema_name,
            cinema_address: cinema_address,
            fromDate: moment(this.fromDate).format("YYYY-MM-DD"),
            toDate: moment(this.toDate).format("YYYY-MM-DD"),
            isPdf,
            isExcel,
          };

          if (this.selectedMovieName && this.selectedMovieName.length) {
            payload["selectedMovieName"] = this.selectedMovieName.map(
              (offerObj) => {
                return offerObj.movie_name;
              }
            );
          }

          let response = await NewReportService.GetMovieShowWiseReport(payload);

          const { data } = response;
          if (data.status && data.Records.length) {
            this.showDetailsData = [...data.Records];
            this.grandTotal = data.grandTotal;
            if (data.pdfPath && isPdf == "Y") {
              window.open(data.pdfPath, "_blank");
            }
            if (data.excelPath && isExcel == "Y") {
              window.open(data.excelPath, "_blank");
            }
          } else {
            this.$toasted.show(data.message);
          }
        } catch (error) {
          console.log(error);
        } finally {
          if (loader) {
            loader.hide();
          }
        }
      },
    },
  };
</script>

<style scoped>
  .left-border {
    border-left: 1px solid black !important;
    border-top: 0 !important;
    border-bottom: 1px solid black !important;
    border-right: 0 !important;
  }

  .right-border {
    border-left: 0 !important;
    border-top: 0 !important;
    border-right: 1px solid black !important;
    border-bottom: 1px solid black !important;
  }

  .concession-analysis-table {
    width: 100%;
    border: 1px solid #787878;
  }

  .concession-analysis-table thead {
    text-align: center;
    background-color: #dddedf;
  }

  .concession-analysis-table thead th {
    padding: 5px;
    border: 1px solid #000;
  }

  .concession-analysis-table tbody {
    border-bottom: 1px solid #000;
  }

  .concession-analysis-table tbody td {
    padding: 2.5px 5px;
    border-left: 1px solid #787878;
    border-right: 1px solid #787878;
  }

  .concession-analysis-table tbody td p {
    font-weight: bold;
    margin-bottom: 0;
  }

  .gcamp-tr td {
    width: 13%;
    border: 1px solid #000;
  }

  .swc-report-table {
    table-layout: auto !important;
    overflow-x: scroll !important;
    border: 1px solid black;
  }

  .swc-report-table td {
    white-space: nowrap;
  }

  .swc-report-table th {
    white-space: nowrap !important;
    border: 1px solid black !important;
  }

  .swc_table_header th {
    border: 1px solid black !important;
  }

  .borderOnly {
    border-left: 0px !important;
    border-top: 0px !important;
    border-bottom: 0px !important;
    border-right: 1px !important;
  }

  .no_border {
    border: 0px !important;
  }

  .concession_blue {
    background-color: #c5d6f0 !important;
  }
</style>

 


// WEBPACK FOOTER //
// src/components/Pages/ReportsContainer/movieShowWiseReport.vue